export default __webpack_public_path__ + "locales/lo-LA/CreateEditRoomDialog.json?hash=0eaeb9ca0624a3314a6fdd9614cc45f0";